import { IProject } from '../../models/IProject';

function getProjectId(projectName: string, projects: IProject[]): string {
    let projectId = null;

    for (let i = 0; i < projects.length; i++) {
        if (projects[i].name === projectName) {
            projectId = projects[i].projectId;
            break;
        }
    }

    return projectId;
}

export default getProjectId;
